import { RouteConfig } from 'vue-router';
import { CostAnalysisRoutes } from '../costAnalysis/routes';
import { InvestmentRoutes } from '../investment/routes';
import { ReportingRoutes } from '../reporting/routes';
import Organisation from '@/models/Organisation';
import OrganisationType from '@/models/OrganisationType';
import { AssetOwnerModuleRoutes } from '@/modules/assetOwner/routes';

const OrganisationModule = () =>
  import(
    /* webpackChunkName: 'organisation' */ '@/modules/organisation/OrganisationModule.vue'
  );
const OrganisationDashboardPage = () =>
  import(
    /* webpackChunkName: 'organisation' */ '@/modules/organisation/pages/OrganisationDashboardPage.vue'
  );

export const OrganisationRoutes: RouteConfig[] = [
  {
    path: 'organisation/:organisationId',
    component: OrganisationModule,
    props: true,
    meta: {
      title: 'Organisation'
    },
    children: [
      {
        path: '',
        component: OrganisationDashboardPage,
        props: true,
        name: 'dashboard.organisation',
        redirect: to => {
          const allowedOrgTypes: OrganisationType['slug'][] = [
            'pension-scheme',
            'provider',
            'consultant'
          ];
          if (
            allowedOrgTypes.includes(to.params.organisationType) &&
            process.env.VUE_APP_ENABLE_NEW_UI === 'enabled'
          ) {
            return { name: 'dashboard.organisation.clients' };
          } else if (to.params.organisationType) {
            return { name: 'dashboard.organisation.investments' };
          }
          return { name: 'Page404' };
        }
      },
      ...AssetOwnerModuleRoutes,
      ...InvestmentRoutes,
      ...CostAnalysisRoutes,
      ...ReportingRoutes
    ]
  }
];
